import globalAxios from 'axios';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, createRequestFunction, serializeDataIfNeeded, setApiKeyToObject, setSearchParams, toPathString, } from './common';
/**
 *
 * @export
 * @enum {string}
 */
export const ModelBillingFrequency = {
    BillingFrequencyHourly: 'HOURLY',
    BillingFrequencyWeekly: 'WEEKLY',
    BillingFrequencyBiWeekly: 'BI_WEEKLY',
    BillingFrequencyMonthly: 'MONTHLY',
    BillingFrequencyQuarterly: 'QUARTERLY',
};
/**
 * BillingPeriodsApi - axios parameter creator
 * @export
 */
export const BillingPeriodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {string} [fromDate] Filter by start date (YYYY-MM-DD format)
         * @param {string} [toDate] Filter by end date (YYYY-MM-DD format)
         * @param {boolean} [includeFuture] Include future billing periods
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1BillingPeriodsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsGet: async (fromDate, toDate, includeFuture, subscriptionID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/billing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (includeFuture !== undefined) {
                localVarQueryParameter['includeFuture'] = includeFuture;
            }
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdGet', 'id', id);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {string} id Billing Period ID
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdPut: async (id, billingPeriod, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdPut', 'id', id);
            // verify required parameter 'billingPeriod' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdPut', 'billingPeriod', billingPeriod);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billingPeriod, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsPost: async (billingPeriod, options = {}) => {
            // verify required parameter 'billingPeriod' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsPost', 'billingPeriod', billingPeriod);
            const localVarPath = `/operations/v1/billing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billingPeriod, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillingPeriodsApi - functional programming interface
 * @export
 */
export const BillingPeriodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillingPeriodsApiAxiosParamCreator(configuration);
    return {
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {string} [fromDate] Filter by start date (YYYY-MM-DD format)
         * @param {string} [toDate] Filter by end date (YYYY-MM-DD format)
         * @param {boolean} [includeFuture] Include future billing periods
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1BillingPeriodsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsGet(fromDate, toDate, includeFuture, subscriptionID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsGet(fromDate, toDate, includeFuture, subscriptionID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {string} id Billing Period ID
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdPut(id, billingPeriod, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdPut(id, billingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsPost(billingPeriod, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsPost(billingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillingPeriodsApi - factory interface
 * @export
 */
export const BillingPeriodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillingPeriodsApiFp(configuration);
    return {
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1BillingPeriodsGet(requestParameters.fromDate, requestParameters.toDate, requestParameters.includeFuture, requestParameters.subscriptionID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1BillingPeriodsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdGet(requestParameters, options) {
            return localVarFp.operationsV1BillingPeriodsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1BillingPeriodsIdPut(requestParameters.id, requestParameters.billingPeriod, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsPost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingPeriodsPost(requestParameters.billingPeriod, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillingPeriodsApi - object-oriented interface
 * @export
 * @class BillingPeriodsApi
 * @extends {BaseAPI}
 */
export class BillingPeriodsApi extends BaseAPI {
    /**
     * List all billing periods including future ones if includeFuture is true
     * @summary List billing periods
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingPeriodsApi
     */
    operationsV1BillingPeriodsGet(requestParameters = {}, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsGet(requestParameters.fromDate, requestParameters.toDate, requestParameters.includeFuture, requestParameters.subscriptionID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a billing period by ID
     * @summary Delete a billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingPeriodsApi
     */
    operationsV1BillingPeriodsIdDelete(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a billing period by its ID
     * @summary Get billing period by ID
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingPeriodsApi
     */
    operationsV1BillingPeriodsIdGet(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing billing period
     * @summary Update a billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingPeriodsApi
     */
    operationsV1BillingPeriodsIdPut(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdPut(requestParameters.id, requestParameters.billingPeriod, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new billing period
     * @summary Create a new billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingPeriodsApi
     */
    operationsV1BillingPeriodsPost(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsPost(requestParameters.billingPeriod, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1BillingPeriodsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DocRefsApi - axios parameter creator
 * @export
 */
export const DocRefsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [reftype] Filter by ref type
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {OperationsV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsGet: async (id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (docsDocID !== undefined) {
                localVarQueryParameter['docsDocID'] = docsDocID;
            }
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (reftype !== undefined) {
                localVarQueryParameter['reftype'] = reftype;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdGet', 'id', id);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdPut: async (id, docRef, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdPut', 'id', id);
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('operationsV1DocRefsIdPut', 'docRef', docRef);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsPost: async (docRef, options = {}) => {
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('operationsV1DocRefsPost', 'docRef', docRef);
            const localVarPath = `/operations/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocRefsApi - functional programming interface
 * @export
 */
export const DocRefsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocRefsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [reftype] Filter by ref type
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {OperationsV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsGet(id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsGet(id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdPut(id, docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdPut(id, docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsPost(docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsPost(docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocRefsApi - factory interface
 * @export
 */
export const DocRefsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocRefsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {DocRefsApiOperationsV1DocRefsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.reftype, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {DocRefsApiOperationsV1DocRefsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1DocRefsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {DocRefsApiOperationsV1DocRefsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdGet(requestParameters, options) {
            return localVarFp.operationsV1DocRefsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {DocRefsApiOperationsV1DocRefsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {DocRefsApiOperationsV1DocRefsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsPost(requestParameters, options) {
            return localVarFp.operationsV1DocRefsPost(requestParameters.docRef, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocRefsApi - object-oriented interface
 * @export
 * @class DocRefsApi
 * @extends {BaseAPI}
 */
export class DocRefsApi extends BaseAPI {
    /**
     * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
     * @summary List all doc refs
     * @param {DocRefsApiOperationsV1DocRefsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocRefsApi
     */
    operationsV1DocRefsGet(requestParameters = {}, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.reftype, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc ref from the system using its unique identifier
     * @summary Delete a doc ref
     * @param {DocRefsApiOperationsV1DocRefsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocRefsApi
     */
    operationsV1DocRefsIdDelete(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc ref using its unique identifier
     * @summary Get a doc ref by ID
     * @param {DocRefsApiOperationsV1DocRefsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocRefsApi
     */
    operationsV1DocRefsIdGet(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc ref with the provided details
     * @summary Update a doc ref
     * @param {DocRefsApiOperationsV1DocRefsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocRefsApi
     */
    operationsV1DocRefsIdPut(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc ref with the provided details
     * @summary Create a new doc ref
     * @param {DocRefsApiOperationsV1DocRefsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocRefsApi
     */
    operationsV1DocRefsPost(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsPost(requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1DocRefsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DocsApi - axios parameter creator
 * @export
 */
export const DocsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsGet: async (refID, refType, limit, offset, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (refType !== undefined) {
                localVarQueryParameter['refType'] = refType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/docs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdGet', 'id', id);
            const localVarPath = `/operations/v1/docs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdPut: async (id, doc, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdPut', 'id', id);
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('operationsV1DocsIdPut', 'doc', doc);
            const localVarPath = `/operations/v1/docs/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsPost: async (doc, options = {}) => {
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('operationsV1DocsPost', 'doc', doc);
            const localVarPath = `/operations/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocsApi - functional programming interface
 * @export
 */
export const DocsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsGet(refID, refType, limit, offset, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsGet(refID, refType, limit, offset, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdPut(id, doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdPut(id, doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsPost(doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsPost(doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocsApi - factory interface
 * @export
 */
export const DocsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocsApiFp(configuration);
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {DocsApiOperationsV1DocsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1DocsGet(requestParameters.refID, requestParameters.refType, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {DocsApiOperationsV1DocsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1DocsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {DocsApiOperationsV1DocsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdGet(requestParameters, options) {
            return localVarFp.operationsV1DocsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {DocsApiOperationsV1DocsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {DocsApiOperationsV1DocsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsPost(requestParameters, options) {
            return localVarFp.operationsV1DocsPost(requestParameters.doc, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocsApi - object-oriented interface
 * @export
 * @class DocsApi
 * @extends {BaseAPI}
 */
export class DocsApi extends BaseAPI {
    /**
     * Get a list of documents with optional filtering and pagination
     * @summary List documents
     * @param {DocsApiOperationsV1DocsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    operationsV1DocsGet(requestParameters = {}, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsGet(requestParameters.refID, requestParameters.refType, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc from the system using its unique identifier
     * @summary Delete a doc
     * @param {DocsApiOperationsV1DocsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    operationsV1DocsIdDelete(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc using its unique identifier
     * @summary Get a doc by ID
     * @param {DocsApiOperationsV1DocsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    operationsV1DocsIdGet(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc with the provided details
     * @summary Update a doc
     * @param {DocsApiOperationsV1DocsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    operationsV1DocsIdPut(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc with the provided details
     * @summary Create a new doc
     * @param {DocsApiOperationsV1DocsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    operationsV1DocsPost(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsPost(requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EquipmentParamOptionsApi - axios parameter creator
 * @export
 */
export const EquipmentParamOptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {string} [id] Filter by equipment parameter option ID
         * @param {string} [equipmentParamId] Filter by equipment parameter ID
         * @param {string} [value] Filter by value
         * @param {string} [label] Filter by label
         * @param {string} [equipmentParamKey] Filter by equipment parameter key, i.e size will return all options for the size parameter
         * @param {string} [sortBy] Sort by field (id, equipmentParamId, value, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamOptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsGet: async (id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/equipment-param-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (equipmentParamId !== undefined) {
                localVarQueryParameter['equipmentParamId'] = equipmentParamId;
            }
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (equipmentParamKey !== undefined) {
                localVarQueryParameter['equipmentParamKey'] = equipmentParamKey;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single equipment parameter option by its ID. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdPut: async (id, equipmentParamOption, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdPut', 'id', id);
            // verify required parameter 'equipmentParamOption' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdPut', 'equipmentParamOption', equipmentParamOption);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParamOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsPost: async (equipmentParamOption, options = {}) => {
            // verify required parameter 'equipmentParamOption' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsPost', 'equipmentParamOption', equipmentParamOption);
            const localVarPath = `/operations/v1/equipment-param-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParamOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentParamOptionsApi - functional programming interface
 * @export
 */
export const EquipmentParamOptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentParamOptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {string} [id] Filter by equipment parameter option ID
         * @param {string} [equipmentParamId] Filter by equipment parameter ID
         * @param {string} [value] Filter by value
         * @param {string} [label] Filter by label
         * @param {string} [equipmentParamKey] Filter by equipment parameter key, i.e size will return all options for the size parameter
         * @param {string} [sortBy] Sort by field (id, equipmentParamId, value, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamOptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsGet(id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsGet(id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdDelete']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single equipment parameter option by its ID. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdPut(id, equipmentParamOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdPut(id, equipmentParamOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsPost(equipmentParamOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsPost(equipmentParamOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentParamOptionsApi - factory interface
 * @export
 */
export const EquipmentParamOptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentParamOptionsApiFp(configuration);
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsGet(requestParameters.id, requestParameters.equipmentParamId, requestParameters.value, requestParameters.label, requestParameters.equipmentParamKey, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single equipment parameter option by its ID. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdGet(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdGet(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdPut(requestParameters.id, requestParameters.equipmentParamOption, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsPost(requestParameters.equipmentParamOption, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentParamOptionsApi - object-oriented interface
 * @export
 * @class EquipmentParamOptionsApi
 * @extends {BaseAPI}
 */
export class EquipmentParamOptionsApi extends BaseAPI {
    /**
     * Get all equipment parameter options with optional filtering, sorting, and pagination
     * @summary List all equipment parameter options
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamOptionsApi
     */
    operationsV1EquipmentParamOptionsGet(requestParameters = {}, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsGet(requestParameters.id, requestParameters.equipmentParamId, requestParameters.value, requestParameters.label, requestParameters.equipmentParamKey, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
     * @summary Delete an equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamOptionsApi
     */
    operationsV1EquipmentParamOptionsIdDelete(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single equipment parameter option by its ID. Returns 404 if not found.
     * @summary Get an equipment parameter option by ID
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamOptionsApi
     */
    operationsV1EquipmentParamOptionsIdGet(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
     * @summary Update an equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamOptionsApi
     */
    operationsV1EquipmentParamOptionsIdPut(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdPut(requestParameters.id, requestParameters.equipmentParamOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
     * @summary Create a new equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamOptionsApi
     */
    operationsV1EquipmentParamOptionsPost(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsPost(requestParameters.equipmentParamOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1EquipmentParamOptionsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * EquipmentParamsApi - axios parameter creator
 * @export
 */
export const EquipmentParamsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {string} [id] Filter by equipment parameter ID
         * @param {string} [equipmentTypeId] Filter by equipment type ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [key] Filter by equipment parameter key
         * @param {string} [label] Filter by equipment parameter label
         * @param {string} [sortBy] Sort by field (id, equipmentTypeId, haulerID, key, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsGet: async (id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/equipment-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (equipmentTypeId !== undefined) {
                localVarQueryParameter['equipmentTypeId'] = equipmentTypeId;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdPut: async (id, equipmentParam, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdPut', 'id', id);
            // verify required parameter 'equipmentParam' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdPut', 'equipmentParam', equipmentParam);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsPost: async (equipmentParam, options = {}) => {
            // verify required parameter 'equipmentParam' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsPost', 'equipmentParam', equipmentParam);
            const localVarPath = `/operations/v1/equipment-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentParamsApi - functional programming interface
 * @export
 */
export const EquipmentParamsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentParamsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {string} [id] Filter by equipment parameter ID
         * @param {string} [equipmentTypeId] Filter by equipment type ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [key] Filter by equipment parameter key
         * @param {string} [label] Filter by equipment parameter label
         * @param {string} [sortBy] Sort by field (id, equipmentTypeId, haulerID, key, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsGet(id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsGet(id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdPut(id, equipmentParam, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdPut(id, equipmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsPost(equipmentParam, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsPost(equipmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentParamsApi - factory interface
 * @export
 */
export const EquipmentParamsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentParamsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentParamsGet(requestParameters.id, requestParameters.equipmentTypeId, requestParameters.haulerID, requestParameters.key, requestParameters.label, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdGet(requestParameters, options) {
            return localVarFp.operationsV1EquipmentParamsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsIdPut(requestParameters.id, requestParameters.equipmentParam, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsPost(requestParameters.equipmentParam, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentParamsApi - object-oriented interface
 * @export
 * @class EquipmentParamsApi
 * @extends {BaseAPI}
 */
export class EquipmentParamsApi extends BaseAPI {
    /**
     * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
     * @summary List all equipment parameters
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamsApi
     */
    operationsV1EquipmentParamsGet(requestParameters = {}, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsGet(requestParameters.id, requestParameters.equipmentTypeId, requestParameters.haulerID, requestParameters.key, requestParameters.label, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an equipment parameter by its ID
     * @summary Delete an equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamsApi
     */
    operationsV1EquipmentParamsIdDelete(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single equipment parameter by its ID
     * @summary Get a single equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamsApi
     */
    operationsV1EquipmentParamsIdGet(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing equipment parameter with the provided data
     * @summary Update an equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamsApi
     */
    operationsV1EquipmentParamsIdPut(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdPut(requestParameters.id, requestParameters.equipmentParam, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment parameter with the provided data
     * @summary Create a new equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentParamsApi
     */
    operationsV1EquipmentParamsPost(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsPost(requestParameters.equipmentParam, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1EquipmentParamsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * EquipmentTypesApi - axios parameter creator
 * @export
 */
export const EquipmentTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {string} [id] Filter by equipment type ID
         * @param {string} [name] Filter by name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentTypesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesGet: async (id, name, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/equipment-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {string} id Equipment Type ID
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdPut: async (id, equipmentType, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdPut', 'id', id);
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdPut', 'equipmentType', equipmentType);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesPost: async (equipmentType, options = {}) => {
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesPost', 'equipmentType', equipmentType);
            const localVarPath = `/operations/v1/equipment-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentTypesApi - functional programming interface
 * @export
 */
export const EquipmentTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentTypesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {string} [id] Filter by equipment type ID
         * @param {string} [name] Filter by name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentTypesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesGet(id, name, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesGet(id, name, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {string} id Equipment Type ID
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdPut(id, equipmentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdPut(id, equipmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesPost(equipmentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesPost(equipmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentTypesApi - factory interface
 * @export
 */
export const EquipmentTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentTypesApiFp(configuration);
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentTypesGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdDelete(requestParameters, options) {
            return localVarFp.operationsV1EquipmentTypesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdGet(requestParameters, options) {
            return localVarFp.operationsV1EquipmentTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentTypesIdPut(requestParameters.id, requestParameters.equipmentType, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentTypesPost(requestParameters.equipmentType, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentTypesApi - object-oriented interface
 * @export
 * @class EquipmentTypesApi
 * @extends {BaseAPI}
 */
export class EquipmentTypesApi extends BaseAPI {
    /**
     * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
     * @summary List all equipment types
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentTypesApi
     */
    operationsV1EquipmentTypesGet(requestParameters = {}, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove an equipment type from the system using its unique identifier
     * @summary Delete an equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentTypesApi
     */
    operationsV1EquipmentTypesIdDelete(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single equipment type using its unique identifier
     * @summary Get an equipment type by ID
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentTypesApi
     */
    operationsV1EquipmentTypesIdGet(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing equipment type with the provided details
     * @summary Update an equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentTypesApi
     */
    operationsV1EquipmentTypesIdPut(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdPut(requestParameters.id, requestParameters.equipmentType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment type with the provided details
     * @summary Create a new equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentTypesApi
     */
    operationsV1EquipmentTypesPost(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesPost(requestParameters.equipmentType, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1EquipmentTypesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationHaulerId] Filter by hauler ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {OperationsV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsGet: async (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }
            if (locationHaulerId !== undefined) {
                localVarQueryParameter['locationHaulerId'] = locationHaulerId;
            }
            if (locationCity !== undefined) {
                localVarQueryParameter['locationCity'] = locationCity;
            }
            if (locationState !== undefined) {
                localVarQueryParameter['locationState'] = locationState;
            }
            if (locationPostcode !== undefined) {
                localVarQueryParameter['locationPostcode'] = locationPostcode;
            }
            if (locationCountry !== undefined) {
                localVarQueryParameter['locationCountry'] = locationCountry;
            }
            if (locationLabel !== undefined) {
                localVarQueryParameter['locationLabel'] = locationLabel;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdGet', 'id', id);
            const localVarPath = `/operations/v1/locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdPut: async (id, location, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdPut', 'id', id);
            // verify required parameter 'location' is not null or undefined
            assertParamExists('operationsV1LocationsIdPut', 'location', location);
            const localVarPath = `/operations/v1/locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsPost: async (location, options = {}) => {
            // verify required parameter 'location' is not null or undefined
            assertParamExists('operationsV1LocationsPost', 'location', location);
            const localVarPath = `/operations/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationHaulerId] Filter by hauler ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {OperationsV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsGet(locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsGet(locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdPut(id, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdPut(id, location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsPost(location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsPost(location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {LocationsApiOperationsV1LocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1LocationsGet(requestParameters.locationId, requestParameters.locationHaulerId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {LocationsApiOperationsV1LocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1LocationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {LocationsApiOperationsV1LocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdGet(requestParameters, options) {
            return localVarFp.operationsV1LocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {LocationsApiOperationsV1LocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {LocationsApiOperationsV1LocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsPost(requestParameters, options) {
            return localVarFp.operationsV1LocationsPost(requestParameters.location, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
     * @summary List all locations
     * @param {LocationsApiOperationsV1LocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    operationsV1LocationsGet(requestParameters = {}, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsGet(requestParameters.locationId, requestParameters.locationHaulerId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing location by its ID
     * @summary delete a location
     * @param {LocationsApiOperationsV1LocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    operationsV1LocationsIdDelete(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single location by its ID
     * @summary Get a location by ID
     * @param {LocationsApiOperationsV1LocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    operationsV1LocationsIdGet(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing location with the provided data
     * @summary update a location
     * @param {LocationsApiOperationsV1LocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    operationsV1LocationsIdPut(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new location with the provided data
     * @summary create a new location
     * @param {LocationsApiOperationsV1LocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    operationsV1LocationsPost(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsPost(requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1LocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderCommercialsApi - axios parameter creator
 * @export
 */
export const OrderCommercialsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {string} [orderCommercialId] Filter by order commercial ID
         * @param {string} [orderCommercialOrderId] Filter by order ID
         * @param {string} [orderCommercialSubscriptionId] Filter by subscription ID
         * @param {string} [orderCommercialSubscriptionLocationId] Filter by subscription location ID
         * @param {string} [orderCommercialStatus] Filter by status
         * @param {string} [orderCommercialEquipmentTypeId] Filter by equipment type ID
         * @param {string} [sortBy] Sort by field (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialStartTimestamp, orderCommercialEndTimestamp, orderCommercialSortOrder, orderCommercialCreatedAt, orderCommercialLastUpdatedAt)
         * @param {OperationsV1OrderCommercialsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsGet: async (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/order-commercials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (orderCommercialId !== undefined) {
                localVarQueryParameter['orderCommercialId'] = orderCommercialId;
            }
            if (orderCommercialOrderId !== undefined) {
                localVarQueryParameter['orderCommercialOrderId'] = orderCommercialOrderId;
            }
            if (orderCommercialSubscriptionId !== undefined) {
                localVarQueryParameter['orderCommercialSubscriptionId'] = orderCommercialSubscriptionId;
            }
            if (orderCommercialSubscriptionLocationId !== undefined) {
                localVarQueryParameter['orderCommercialSubscriptionLocationId'] = orderCommercialSubscriptionLocationId;
            }
            if (orderCommercialStatus !== undefined) {
                localVarQueryParameter['orderCommercialStatus'] = orderCommercialStatus;
            }
            if (orderCommercialEquipmentTypeId !== undefined) {
                localVarQueryParameter['orderCommercialEquipmentTypeId'] = orderCommercialEquipmentTypeId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdGet', 'id', id);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {string} id Order Commercial ID
         * @param {ModelOrderCommercial} orderCommercial Order Commercial object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdPut: async (id, orderCommercial, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdPut', 'id', id);
            // verify required parameter 'orderCommercial' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdPut', 'orderCommercial', orderCommercial);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCommercial, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {ModelOrderCommercial} orderCommercial Order Commercial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsPost: async (orderCommercial, options = {}) => {
            // verify required parameter 'orderCommercial' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsPost', 'orderCommercial', orderCommercial);
            const localVarPath = `/operations/v1/order-commercials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCommercial, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderCommercialsApi - functional programming interface
 * @export
 */
export const OrderCommercialsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderCommercialsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {string} [orderCommercialId] Filter by order commercial ID
         * @param {string} [orderCommercialOrderId] Filter by order ID
         * @param {string} [orderCommercialSubscriptionId] Filter by subscription ID
         * @param {string} [orderCommercialSubscriptionLocationId] Filter by subscription location ID
         * @param {string} [orderCommercialStatus] Filter by status
         * @param {string} [orderCommercialEquipmentTypeId] Filter by equipment type ID
         * @param {string} [sortBy] Sort by field (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialStartTimestamp, orderCommercialEndTimestamp, orderCommercialSortOrder, orderCommercialCreatedAt, orderCommercialLastUpdatedAt)
         * @param {OperationsV1OrderCommercialsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsGet(orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsGet(orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {string} id Order Commercial ID
         * @param {ModelOrderCommercial} orderCommercial Order Commercial object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdPut(id, orderCommercial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdPut(id, orderCommercial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {ModelOrderCommercial} orderCommercial Order Commercial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsPost(orderCommercial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsPost(orderCommercial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderCommercialsApi - factory interface
 * @export
 */
export const OrderCommercialsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderCommercialsApiFp(configuration);
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrderCommercialsGet(requestParameters.orderCommercialId, requestParameters.orderCommercialOrderId, requestParameters.orderCommercialSubscriptionId, requestParameters.orderCommercialSubscriptionLocationId, requestParameters.orderCommercialStatus, requestParameters.orderCommercialEquipmentTypeId, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrderCommercialsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsIdPut(requestParameters.id, requestParameters.orderCommercial, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsPost(requestParameters.orderCommercial, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderCommercialsApi - object-oriented interface
 * @export
 * @class OrderCommercialsApi
 * @extends {BaseAPI}
 */
export class OrderCommercialsApi extends BaseAPI {
    /**
     * Get all order commercials with optional filtering and sorting
     * @summary List all order commercials
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCommercialsApi
     */
    operationsV1OrderCommercialsGet(requestParameters = {}, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsGet(requestParameters.orderCommercialId, requestParameters.orderCommercialOrderId, requestParameters.orderCommercialSubscriptionId, requestParameters.orderCommercialSubscriptionLocationId, requestParameters.orderCommercialStatus, requestParameters.orderCommercialEquipmentTypeId, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an order commercial by its ID
     * @summary delete an order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCommercialsApi
     */
    operationsV1OrderCommercialsIdDelete(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single order commercial by its ID
     * @summary Get an order commercial by ID
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCommercialsApi
     */
    operationsV1OrderCommercialsIdGet(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order commercial with the provided data
     * @summary update an order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCommercialsApi
     */
    operationsV1OrderCommercialsIdPut(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdPut(requestParameters.id, requestParameters.orderCommercial, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order commercial
     * @summary create order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCommercialsApi
     */
    operationsV1OrderCommercialsPost(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsPost(requestParameters.orderCommercial, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1OrderCommercialsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderItemsApi - axios parameter creator
 * @export
 */
export const OrderItemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-items/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdPut: async (id, orderItem, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdPut', 'id', id);
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdPut', 'orderItem', orderItem);
            const localVarPath = `/operations/v1/order-items/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsPost: async (orderItem, options = {}) => {
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('operationsV1OrderItemsPost', 'orderItem', orderItem);
            const localVarPath = `/operations/v1/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderItemsApi - functional programming interface
 * @export
 */
export const OrderItemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderItemsApiAxiosParamCreator(configuration);
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsIdPut(id, orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsIdPut(id, orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsPost(orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsPost(orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderItemsApi - factory interface
 * @export
 */
export const OrderItemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderItemsApiFp(configuration);
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {OrderItemsApiOperationsV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrderItemsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {OrderItemsApiOperationsV1OrderItemsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {OrderItemsApiOperationsV1OrderItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsPost(requestParameters, options) {
            return localVarFp.operationsV1OrderItemsPost(requestParameters.orderItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderItemsApi - object-oriented interface
 * @export
 * @class OrderItemsApi
 * @extends {BaseAPI}
 */
export class OrderItemsApi extends BaseAPI {
    /**
     * delete an order item by its ID
     * @summary delete order item
     * @param {OrderItemsApiOperationsV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    operationsV1OrderItemsIdDelete(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order item
     * @summary update order item
     * @param {OrderItemsApiOperationsV1OrderItemsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    operationsV1OrderItemsIdPut(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order item
     * @summary create order item
     * @param {OrderItemsApiOperationsV1OrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    operationsV1OrderItemsPost(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsPost(requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all orders with optional filtering and sorting
         * @summary List all orders
         * @param {string} [orderId] Filter by order ID
         * @param {string} [orderHaulerId] Filter by hauler ID
         * @param {string} [orderCustomerId] Filter by customer ID
         * @param {string} [orderServiceLocationId] Filter by service location ID
         * @param {string} [orderStatus] Filter by status
         * @param {string} [orderSubscriptionId] Filter by subscription ID
         * @param {string} [sortBy] Sort by field
         * @param {OperationsV1OrdersGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersGet: async (orderId, orderHaulerId, orderCustomerId, orderServiceLocationId, orderStatus, orderSubscriptionId, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (orderHaulerId !== undefined) {
                localVarQueryParameter['orderHaulerId'] = orderHaulerId;
            }
            if (orderCustomerId !== undefined) {
                localVarQueryParameter['orderCustomerId'] = orderCustomerId;
            }
            if (orderServiceLocationId !== undefined) {
                localVarQueryParameter['orderServiceLocationId'] = orderServiceLocationId;
            }
            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }
            if (orderSubscriptionId !== undefined) {
                localVarQueryParameter['orderSubscriptionId'] = orderSubscriptionId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdDelete', 'id', id);
            const localVarPath = `/operations/v1/orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdGet', 'id', id);
            const localVarPath = `/operations/v1/orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {string} id Order ID
         * @param {ModelOrder} order Order object
         * @param {boolean} [updateAllLocations] update all subscription orders locations, this only works if an order is part of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdPut: async (id, order, updateAllLocations, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdPut', 'id', id);
            // verify required parameter 'order' is not null or undefined
            assertParamExists('operationsV1OrdersIdPut', 'order', order);
            const localVarPath = `/operations/v1/orders/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (updateAllLocations !== undefined) {
                localVarQueryParameter['updateAllLocations'] = updateAllLocations;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {ModelOrder} order Order object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersPost: async (order, options = {}) => {
            // verify required parameter 'order' is not null or undefined
            assertParamExists('operationsV1OrdersPost', 'order', order);
            const localVarPath = `/operations/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all orders with optional filtering and sorting
         * @summary List all orders
         * @param {string} [orderId] Filter by order ID
         * @param {string} [orderHaulerId] Filter by hauler ID
         * @param {string} [orderCustomerId] Filter by customer ID
         * @param {string} [orderServiceLocationId] Filter by service location ID
         * @param {string} [orderStatus] Filter by status
         * @param {string} [orderSubscriptionId] Filter by subscription ID
         * @param {string} [sortBy] Sort by field
         * @param {OperationsV1OrdersGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersGet(orderId, orderHaulerId, orderCustomerId, orderServiceLocationId, orderStatus, orderSubscriptionId, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersGet(orderId, orderHaulerId, orderCustomerId, orderServiceLocationId, orderStatus, orderSubscriptionId, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {string} id Order ID
         * @param {ModelOrder} order Order object
         * @param {boolean} [updateAllLocations] update all subscription orders locations, this only works if an order is part of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdPut(id, order, updateAllLocations, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdPut(id, order, updateAllLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {ModelOrder} order Order object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersPost(order, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersPost(order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         * Get all orders with optional filtering and sorting
         * @summary List all orders
         * @param {OrdersApiOperationsV1OrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrdersGet(requestParameters.orderId, requestParameters.orderHaulerId, requestParameters.orderCustomerId, requestParameters.orderServiceLocationId, requestParameters.orderStatus, requestParameters.orderSubscriptionId, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {OrdersApiOperationsV1OrdersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrdersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {OrdersApiOperationsV1OrdersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrdersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {OrdersApiOperationsV1OrdersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrdersIdPut(requestParameters.id, requestParameters.order, requestParameters.updateAllLocations, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {OrdersApiOperationsV1OrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersPost(requestParameters, options) {
            return localVarFp.operationsV1OrdersPost(requestParameters.order, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * Get all orders with optional filtering and sorting
     * @summary List all orders
     * @param {OrdersApiOperationsV1OrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    operationsV1OrdersGet(requestParameters = {}, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersGet(requestParameters.orderId, requestParameters.orderHaulerId, requestParameters.orderCustomerId, requestParameters.orderServiceLocationId, requestParameters.orderStatus, requestParameters.orderSubscriptionId, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing order by its ID
     * @summary delete an order
     * @param {OrdersApiOperationsV1OrdersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    operationsV1OrdersIdDelete(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single order by its ID
     * @summary Get an order by ID
     * @param {OrdersApiOperationsV1OrdersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    operationsV1OrdersIdGet(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order with the provided data
     * @summary update an order
     * @param {OrdersApiOperationsV1OrdersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    operationsV1OrdersIdPut(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdPut(requestParameters.id, requestParameters.order, requestParameters.updateAllLocations, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order with the provided data
     * @summary create a new order
     * @param {OrdersApiOperationsV1OrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    operationsV1OrdersPost(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersPost(requestParameters.order, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1OrdersGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLineListOptionsApi - axios parameter creator
 * @export
 */
export const ServiceLineListOptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {string} id Service Line List Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-line-list-options/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {string} id Service Line List Option ID
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdPut: async (id, serviceLineListOption, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdPut', 'id', id);
            // verify required parameter 'serviceLineListOption' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdPut', 'serviceLineListOption', serviceLineListOption);
            const localVarPath = `/operations/v1/service-line-list-options/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineListOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsPost: async (serviceLineListOption, options = {}) => {
            // verify required parameter 'serviceLineListOption' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsPost', 'serviceLineListOption', serviceLineListOption);
            const localVarPath = `/operations/v1/service-line-list-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineListOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLineListOptionsApi - functional programming interface
 * @export
 */
export const ServiceLineListOptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLineListOptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {string} id Service Line List Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsIdDelete']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {string} id Service Line List Option ID
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsIdPut(id, serviceLineListOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsIdPut(id, serviceLineListOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsIdPut']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsPost(serviceLineListOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsPost(serviceLineListOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLineListOptionsApi - factory interface
 * @export
 */
export const ServiceLineListOptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLineListOptionsApiFp(configuration);
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsIdPut(requestParameters.id, requestParameters.serviceLineListOption, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsPost(requestParameters.serviceLineListOption, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLineListOptionsApi - object-oriented interface
 * @export
 * @class ServiceLineListOptionsApi
 * @extends {BaseAPI}
 */
export class ServiceLineListOptionsApi extends BaseAPI {
    /**
     * Delete an existing service line list option by its ID. Returns 404 if not found.
     * @summary Delete a service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListOptionsApi
     */
    operationsV1ServiceLineListOptionsIdDelete(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
     * @summary Update a service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListOptionsApi
     */
    operationsV1ServiceLineListOptionsIdPut(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsIdPut(requestParameters.id, requestParameters.serviceLineListOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
     * @summary Create a new service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListOptionsApi
     */
    operationsV1ServiceLineListOptionsPost(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsPost(requestParameters.serviceLineListOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ServiceLineListsApi - axios parameter creator
 * @export
 */
export const ServiceLineListsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {string} [id] Filter by service line list ID
         * @param {string} [name] Filter by service line list name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLineListsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsGet: async (id, name, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/service-line-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {string} id Service Line List ID
         * @param {ModelServiceLineList} serviceLineList Service Line List object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdPut: async (id, serviceLineList, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdPut', 'id', id);
            // verify required parameter 'serviceLineList' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdPut', 'serviceLineList', serviceLineList);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ModelServiceLineList} serviceLineList Service Line List object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsPost: async (serviceLineList, options = {}) => {
            // verify required parameter 'serviceLineList' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsPost', 'serviceLineList', serviceLineList);
            const localVarPath = `/operations/v1/service-line-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLineListsApi - functional programming interface
 * @export
 */
export const ServiceLineListsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLineListsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {string} [id] Filter by service line list ID
         * @param {string} [name] Filter by service line list name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLineListsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsGet(id, name, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsGet(id, name, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {string} id Service Line List ID
         * @param {ModelServiceLineList} serviceLineList Service Line List object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdPut(id, serviceLineList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdPut(id, serviceLineList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ModelServiceLineList} serviceLineList Service Line List object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsPost(serviceLineList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsPost(serviceLineList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLineListsApi - factory interface
 * @export
 */
export const ServiceLineListsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLineListsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLineListsGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLineListsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsIdPut(requestParameters.id, requestParameters.serviceLineList, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsPost(requestParameters.serviceLineList, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLineListsApi - object-oriented interface
 * @export
 * @class ServiceLineListsApi
 * @extends {BaseAPI}
 */
export class ServiceLineListsApi extends BaseAPI {
    /**
     * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
     * @summary List all service line lists
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListsApi
     */
    operationsV1ServiceLineListsGet(requestParameters = {}, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a service line list from the system using its unique identifier
     * @summary Delete a service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListsApi
     */
    operationsV1ServiceLineListsIdDelete(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single service line list using its unique identifier
     * @summary Get a service line list by ID
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListsApi
     */
    operationsV1ServiceLineListsIdGet(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
     * @summary Update a service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListsApi
     */
    operationsV1ServiceLineListsIdPut(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdPut(requestParameters.id, requestParameters.serviceLineList, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line list with the provided details
     * @summary Create a new service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLineListsApi
     */
    operationsV1ServiceLineListsPost(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsPost(requestParameters.serviceLineList, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1ServiceLineListsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLinesApi - axios parameter creator
 * @export
 */
export const ServiceLinesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {string} [id] Filter by service line ID
         * @param {string} [key] Filter by service line key
         * @param {string} [label] Filter by service line label
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, key, label, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLinesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesGet: async (id, key, label, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/service-lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {string} id Service Line ID
         * @param {ModelServiceLine} serviceLine Service Line object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdPut: async (id, serviceLine, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdPut', 'id', id);
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdPut', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ModelServiceLine} serviceLine Service Line object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesPost: async (serviceLine, options = {}) => {
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1ServiceLinesPost', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/service-lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLinesApi - functional programming interface
 * @export
 */
export const ServiceLinesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLinesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {string} [id] Filter by service line ID
         * @param {string} [key] Filter by service line key
         * @param {string} [label] Filter by service line label
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, key, label, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLinesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesGet(id, key, label, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesGet(id, key, label, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {string} id Service Line ID
         * @param {ModelServiceLine} serviceLine Service Line object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdPut(id, serviceLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdPut(id, serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ModelServiceLine} serviceLine Service Line object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesPost(serviceLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesPost(serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLinesApi - factory interface
 * @export
 */
export const ServiceLinesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLinesApiFp(configuration);
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {ServiceLinesApiOperationsV1ServiceLinesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLinesGet(requestParameters.id, requestParameters.key, requestParameters.label, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdDelete(requestParameters, options) {
            return localVarFp.operationsV1ServiceLinesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLinesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLinesIdPut(requestParameters.id, requestParameters.serviceLine, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLinesPost(requestParameters.serviceLine, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLinesApi - object-oriented interface
 * @export
 * @class ServiceLinesApi
 * @extends {BaseAPI}
 */
export class ServiceLinesApi extends BaseAPI {
    /**
     * Retrieve a list of all service lines with options to filter, sort, and paginate the results
     * @summary List all service lines
     * @param {ServiceLinesApiOperationsV1ServiceLinesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    operationsV1ServiceLinesGet(requestParameters = {}, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesGet(requestParameters.id, requestParameters.key, requestParameters.label, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a service line from the system using its unique identifier
     * @summary Delete a service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    operationsV1ServiceLinesIdDelete(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single service line using its unique identifier
     * @summary Get a service line by ID
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    operationsV1ServiceLinesIdGet(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
     * @summary Update a service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    operationsV1ServiceLinesIdPut(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdPut(requestParameters.id, requestParameters.serviceLine, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line with the provided details
     * @summary Create a new service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    operationsV1ServiceLinesPost(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesPost(requestParameters.serviceLine, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1ServiceLinesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLocationsApi - axios parameter creator
 * @export
 */
export const ServiceLocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {OperationsV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsGet: async (sortDir, options = {}) => {
            const localVarPath = `/operations/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdPut: async (id, serviceLocation, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdPut', 'id', id);
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdPut', 'serviceLocation', serviceLocation);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsPost: async (serviceLocation, options = {}) => {
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsPost', 'serviceLocation', serviceLocation);
            const localVarPath = `/operations/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLocationsApi - functional programming interface
 * @export
 */
export const ServiceLocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {OperationsV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsGet(sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsGet(sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdPut(id, serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdPut(id, serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsPost(serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsPost(serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLocationsApi - factory interface
 * @export
 */
export const ServiceLocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLocationsApiFp(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all service locations
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLocationsGet(requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsPost(requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLocationsApi - object-oriented interface
 * @export
 * @class ServiceLocationsApi
 * @extends {BaseAPI}
 */
export class ServiceLocationsApi extends BaseAPI {
    /**
     * Get all service locations with optional filtering and sorting. Supports pagination and field filtering.
     * @summary List all service locations
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationsApi
     */
    operationsV1ServiceLocationsGet(requestParameters = {}, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsGet(requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing service location by its ID
     * @summary Delete a service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationsApi
     */
    operationsV1ServiceLocationsIdDelete(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single service location by its ID
     * @summary Get a service location by ID
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationsApi
     */
    operationsV1ServiceLocationsIdGet(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing service location with the provided data
     * @summary Update a service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationsApi
     */
    operationsV1ServiceLocationsIdPut(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service location with the provided data
     * @summary Create a new service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationsApi
     */
    operationsV1ServiceLocationsPost(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsPost(requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1ServiceLocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {string} [subscriptionID] Filter by subscription IDs
         * @param {string} [status] Filter by subscription status
         * @param {string} [startDate] Filter by start date (RFC3339 format)
         * @param {string} [endDate] Filter by end date (RFC3339 format)
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1SubscriptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsGet: async (subscriptionID, status, startDate, endDate, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdGet', 'id', id);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {string} id Subscription ID
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdPut: async (id, subscription, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdPut', 'id', id);
            // verify required parameter 'subscription' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdPut', 'subscription', subscription);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(subscription, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new subscription with the provided details
         * @summary Create a new subscription
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsPost: async (subscription, options = {}) => {
            // verify required parameter 'subscription' is not null or undefined
            assertParamExists('operationsV1SubscriptionsPost', 'subscription', subscription);
            const localVarPath = `/operations/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(subscription, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {object} query Search query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsSearchPost: async (query, options = {}) => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('operationsV1SubscriptionsSearchPost', 'query', query);
            const localVarPath = `/operations/v1/subscriptions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(query, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {string} [subscriptionID] Filter by subscription IDs
         * @param {string} [status] Filter by subscription status
         * @param {string} [startDate] Filter by start date (RFC3339 format)
         * @param {string} [endDate] Filter by end date (RFC3339 format)
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1SubscriptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsGet(subscriptionID, status, startDate, endDate, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsGet(subscriptionID, status, startDate, endDate, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {string} id Subscription ID
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdPut(id, subscription, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdPut(id, subscription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new subscription with the provided details
         * @summary Create a new subscription
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsPost(subscription, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsPost(subscription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {object} query Search query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsSearchPost(query, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsSearchPost(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SubscriptionsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {SubscriptionsApiOperationsV1SubscriptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1SubscriptionsGet(requestParameters.subscriptionID, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1SubscriptionsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdGet(requestParameters, options) {
            return localVarFp.operationsV1SubscriptionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsIdPut(requestParameters.id, requestParameters.subscription, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new subscription with the provided details
         * @summary Create a new subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsPost(requestParameters.subscription, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {SubscriptionsApiOperationsV1SubscriptionsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsSearchPost(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsSearchPost(requestParameters.query, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
     * @summary List all subscriptions
     * @param {SubscriptionsApiOperationsV1SubscriptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsGet(requestParameters = {}, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsGet(requestParameters.subscriptionID, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a subscription from the system using its unique identifier
     * @summary Delete a subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsIdDelete(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single subscription using its unique identifier
     * @summary Get a subscription by ID
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsIdGet(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing subscription with the provided details
     * @summary update a subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsIdPut(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdPut(requestParameters.id, requestParameters.subscription, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new subscription with the provided details
     * @summary Create a new subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsPost(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsPost(requestParameters.subscription, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for subscriptions based on provided search criteria
     * @summary Search subscriptions
     * @param {SubscriptionsApiOperationsV1SubscriptionsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    operationsV1SubscriptionsSearchPost(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsSearchPost(requestParameters.query, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OperationsV1SubscriptionsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
